import { HttpTypes } from '@/types';
import { ICourier } from '@/types/general';
import { AxiosInstance } from 'axios';

class Shipping {
  private client: AxiosInstance;
  private routePath = '/sites';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(): Promise<HttpTypes.IResponse<ICourier[]>> {
    const result = await this.client.get(`${this.routePath}/courier-store`);
    return result.data;
  }

  async update(payload: HttpTypes.AdminUpdateShippingSettingPayload) {
    const result = await this.client.post(`${this.routePath}/courier-setting`, payload);
    return result.data;
  }
}

export default Shipping;
